import { useBillingServiceStore } from '@tom-ui/billing'
import { useOperationsStore } from '@tom-ui/operations'
import { usePlanningStore } from '@tom-ui/planning'
import { IssueResolutionViewStore } from '@tom-ui/planning/pages/Issues/Stores/IssueResolutionViewStore'
import { IssuesViewStore } from '@tom-ui/planning/pages/Issues/Stores/IssuesViewStore'
import { useYardStores } from '@tom-ui/yard'
import { useLocalObservable } from 'mobx-react-lite'
import {
  AggregateIssuesViewStore,
  OperationStores,
  PlanningStores,
  YardStores,
} from './../Stores/AggregateIssuesViewStore'

export const useAggregateIssuesViewStore = () => {
  const {
    issueItemStore,
    containerJourneyItemStore, //use ItemStore instead of DataStore
    containerItemStore,
    railVisitItemStore,
    railcarTrackPositionItemStore,
    railcarItemStore,
  } = usePlanningStore()
  const { issueUIStore } = useOperationsStore()
  const { yardIssueUIStore, journeyStore } = useYardStores()

  const issuesViewStore = useLocalObservable(() => {
    return new IssuesViewStore(
      issueItemStore,
      containerJourneyItemStore,
      containerItemStore,
      railVisitItemStore,
      railcarTrackPositionItemStore,
    )
  })

  const { companyDialogUIStore } = useBillingServiceStore()
  const issueResolutionViewStore = useLocalObservable(() => {
    return new IssueResolutionViewStore(companyDialogUIStore)
  })

  const planningStores: PlanningStores = {
    issueViewStore: issuesViewStore,
    issueResolutionViewStore: issueResolutionViewStore,
    railcarItemStore: railcarItemStore,
  }

  const operationStore: OperationStores = {
    issueViewStore: issueUIStore,
  }

  const yardStore: YardStores = {
    issueViewStore: yardIssueUIStore,
    journeyStore,
  }

  const aggregateIssuesViewStore = useLocalObservable(() => {
    return new AggregateIssuesViewStore(
      planningStores,
      operationStore,
      yardStore,
      containerJourneyItemStore,
    )
  })

  return { aggregateIssuesViewStore }
}
